import './js/ballot.js';
import './sass/style.scss';